import React, { useEffect, useState } from "react";

// Returns the width of the viewport
const useViewport = () => {
  const [deviceWidth, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return { deviceWidth };
};

export default useViewport;
